import { Link } from 'react-router-dom';

interface AdFilterContainerProps {
  children?: React.ReactNode;
}

export default function AdFilterContainer({ children }: AdFilterContainerProps) {
  return (
    <div className="col-lg-3" style={{ width: 'calc(25% * 0.8)' }}>
      <div
        className="d-flex flex-column overflow-hidden"
        style={{ maxHeight: 'calc(100vh - 120px)' }}
      >
        <div className="flex-shrink-0">
          <Link className="btn btn-primary w-100 mb-2" to="/teknik-destek">
            <i className="fas fa-tools me-2" />
            Teknik Destek
          </Link>
          <Link className="btn btn-primary w-100 mb-4" to="/gonderiler">
            <i className="fas fa-video me-2" />
            Gönderiler
          </Link>
        </div>
        <div
          className="flex-grow-1 overflow-y-auto"
          style={{ minHeight: 0 }}
        >
          {children}
        </div>
      </div>
    </div>
  );
}